import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-12th">12th</span>
          <span className="logo-plus">plus</span>
          <span className="logo-com">.com</span>
        </Link>
        <div className="navbar-tagline">Clarity, Confidence & Smarter Decisions</div>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {mobileMenuOpen ? (
              <path d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path d="M3 12h18M3 6h18M3 18h18" />
            )}
          </svg>
        </button>

        <div className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/students"
            className={`nav-link ${isActive('/students') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Students & Parents
          </Link>
          <Link
            to="/institutions"
            className={`nav-link ${isActive('/institutions') ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Institutions
          </Link>
          <a href="#about" className="nav-link">About Us</a>
          <a href="#contact" className="nav-link">Contact</a>
          <button className="btn-login">Login</button>
          <button className="btn-signup">Get Started</button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
